import React, { useMemo, useRef, useImperativeHandle, forwardRef } from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

const TOOLBAR_OPTIONS = [
  [{ header: [1, 2, 3, false] }],
  ["bold", "italic", "underline", "strike"],
  ["blockquote"],
  [{ color: [] }, { background: [] }],
  [{ list: "ordered" }, { list: "bullet" }],
  [{ indent: "-1" }, { indent: "+1" }],
  ["link"],
  ["clean"],
];

export const RichTextEditor = forwardRef(({ value, onChange, placeholder, className = "", minHeight = "80px" }, ref) => {
  const quillRef = useRef(null);
  const modules = useMemo(() => ({
    toolbar: TOOLBAR_OPTIONS,
  }), []);

  useImperativeHandle(ref, () => ({
    insertText: (text) => {
      const editor = quillRef.current?.getEditor?.();
      if (!editor) return;
      const selection = editor.getSelection();
      if (selection) {
        editor.insertText(selection.index, text);
        editor.setSelection(selection.index + text.length);
      } else {
        // No cursor — append at end
        const length = editor.getLength();
        editor.insertText(length - 1, text);
        editor.setSelection(length - 1 + text.length);
      }
    },
  }));

  return (
    <div className={`rich-text-editor ${className}`} style={{ "--editor-min-height": minHeight }}>
      <ReactQuill
        ref={quillRef}
        theme="snow"
        value={value || ""}
        onChange={onChange}
        placeholder={placeholder}
        modules={modules}
      />
    </div>
  );
});

RichTextEditor.displayName = "RichTextEditor";
export default RichTextEditor;
